
import React from "react";
import { Link } from "react-router-dom";
import "./Blog.css";

const RelatedBlogs = ({ blogs = [] }) => {
  if (!blogs.length) return null;

  return (
    <section className="related-blogs-section">
      <div className="related-blogs-heading">
        <h2>Related Blogs</h2>
        <p>Explore more spiritual insights and articles</p>
      </div>

      <div className="related-blogs-grid">
        {blogs.map((blog) => {
          const description = (
            blog.excerpt ||
            (blog.content || "").replace(/<[^>]*>/g, " ")
          ).trim();

          return (
            <article className="related-blog-card" key={blog.id}>
              <Link
                to={`/blog/${blog.id}`}
                className="related-blog-image"
              >
                {blog.image ? (
                  <img
                    src={blog.image}
                    alt={blog.title || "Related blog"}
                    loading="lazy"
                  />
                ) : (
                  <div className="related-blog-no-image">
                    Spiritual Insights
                  </div>
                )}
              </Link>

              <div className="related-blog-content">
                {blog.category && (
                  <span className="related-blog-category">
                    {blog.category}
                  </span>
                )}

                <h3>
                  <Link to={`/blog/${blog.id}`}>
                    {blog.title}
                  </Link>
                </h3>

                <p>
                  {description.length > 120
                    ? `${description.slice(0, 120)}...`
                    : description}
                </p>

                <Link
                  to={`/blog/${blog.id}`}
                  className="related-blog-link"
                >
                  Read Full Article →
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default RelatedBlogs;
